export default `uniform vec3 color;

void main() {
    vec2 xy = gl_PointCoord.xy - vec2(0.5);
    float d = length(xy);

    if (d > 0.50) discard;

    
    float alpha = 1.0 - smoothstep(0.47, 0.50, d);

    
    float fillToWhite = smoothstep(0.37, 0.39, d);   
    float whiteToDark = smoothstep(0.43, 0.45, d);   

    
    float specular  = (1.0 - smoothstep(0.0, 0.16, d)) * 0.5;
    vec3  fillColor = mix(color, vec3(1.0), specular);

    
    vec3 result = mix(fillColor,    vec3(1.00),              fillToWhite);
    result      = mix(result,       vec3(0.10, 0.10, 0.10),  whiteToDark);

    gl_FragColor = vec4(result, alpha);
}`